import { SignupFlowSlug } from "@./state";

export const signupSteps: { label: string; slugs: SignupFlowSlug[] }[] = [
  {
    label: "Basics",
    slugs: [
      SignupFlowSlug.CAT_COUNT,
      SignupFlowSlug.BASIC_INFORMATION,
      SignupFlowSlug.AGE,
    ],
  },
  {
    label: "Food Habits",
    slugs: [
      SignupFlowSlug.EATING_HABITS,
      SignupFlowSlug.MOTIVATION,
    ],
  },
  {
    label: "Activity",
    slugs: [
      SignupFlowSlug.FITNESS,
      SignupFlowSlug.WEIGHT,
      SignupFlowSlug.CURRENT_DIET,
    ],
  },
  {
    label: "Health",
    slugs: [
      SignupFlowSlug.MEDICAL_CONDITIONS,
      SignupFlowSlug.ALLERGIES,
    ],
  },
];
